import React, {Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';

import ShortCodes from './Form/ShortCodes';
import Templates   from './Form/Templates';
import Sequences   from './Form/Sequences';
import Collections from './Form/Collections';
import EmailSection from './EmailSection';


export default function Index(props){

  return(
    <Switch>
      <Route path='/email/shortCodes/new' render={(route)=><ShortCodes {...props} {...route}/>}/>
      <Route path='/email/templates/new' render={(route)=><Templates {...props} {...route}/>}/>
      <Route path='/email/sequences/new' render={(route)=><Sequences {...props} {...route} />}/>
      <Route path='/email/collections/new' render={(route)=><Collections {...props} {...route}/>}/>
      <Route path='/email/shortCodes/:id/edit' render={(route)=><ShortCodes {...props} {...route}/>}/>
      <Route path='/email/templates/:id/edit' render={(route)=><Templates {...props} {...route}/>}/>
      <Route path='/email/sequences/:id/edit' render={(route)=><Sequences {...props} {...route}/>}/>
      <Route path='/email/collections/:id/edit' render={(route)=><Collections {...props} {...route}/>}/>
      <Route path='/email' render={(route)=><EmailSection {...props} {...route}/>}/>
    </Switch>
  )
}
